import { render, staticRenderFns } from "./organization-risk-rating-definiton.vue?vue&type=template&id=04b4672c&scoped=true&"
import script from "./organization-risk-rating-definiton.vue?vue&type=script&lang=js&"
export * from "./organization-risk-rating-definiton.vue?vue&type=script&lang=js&"
import style0 from "./organization-risk-rating-definiton.vue?vue&type=style&index=0&id=04b4672c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b4672c",
  null
  
)

export default component.exports